import type { Question, QuestionnaireAnswers } from '../types/questionnaire';

/**
 * Map answers stored under numeric `Question.id` (how the Zustand store
 * keys them) to the string `Question.field` keys the backend persists.
 *
 * Without this conversion the backend stores `{1: "Growth ($100K-$1M ARR)", ...}`,
 * which is unusable for downstream consumers that look fields up by name
 * (lead scorer at `src/services/lead_scoring/scorer.py` reads
 * `q.get("revenue_range")`; analysis system prompts reference
 * `business_stage`, `challenges`, etc.).
 *
 * Empty strings and missing entries are dropped so the JSONB column
 * doesn't accumulate noise from questions the user skipped.
 */
export function mapAnswersToBackendKeys(
  answers: QuestionnaireAnswers,
  questions: Question[],
): Record<string, string | string[]> {
  const out: Record<string, string | string[]> = {};
  for (const q of questions) {
    const v = answers[q.id];
    if (v === undefined || v === null) continue;
    if (typeof v === 'string' && v.trim() === '') continue;
    if (Array.isArray(v) && v.length === 0) continue;
    out[q.field] = v;
  }
  return out;
}
